import { Component, OnInit } from '@angular/core';
import {
  FormBuilder as NgFormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { IPriceOption } from '../../interfaces/price-options';

@Component({
    selector: 'event-add-price-option-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class EventAddPriceOption implements OnInit {
  public form: FormGroup;

  public constructor(
    private FormBuilder: NgFormBuilder,
    protected DialogRef: MatDialogRef<EventAddPriceOption>
  ) {}

  public ngOnInit() {
    this.form = this.FormBuilder.group({
      priceOption: [null, [Validators.required]],
    });
  }

  public onSubmit() {
    this.form.disable();

    const priceOption: IPriceOption = {
      label: this.form.controls['priceOption'].value,
      slug: this.camelize(this.form.controls['priceOption'].value),
    };

    this.DialogRef.close(priceOption);
  }

  public camelize(label) {
    return label
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        if (+match === 0) return '';
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
      })
      .replace(/-|_/g, '');
  }
}
